import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button';     
import { InputTextarea } from 'primereact/inputtextarea';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import {  editPost } from './../api/axiosPosts'
import { Toast } from 'primereact/toast';
import { useNavigate, useParams } from 'react-router-dom';
import { AllToasts } from './../components/Toasts/AllToasts';
import { useContext } from 'react';
import DataContext from '../context/DataContext';
import { getOnePost } from '../api/axiosPosts';




const Post = () => {
  
  const { setpostPkid, post, setPost, posts, fetcherror, setFetcherror } = useContext(DataContext);
  const toast = useRef(null);
  const navigate = useNavigate();


  const { id } = useParams();
  let postpkid = id;
  localStorage.setItem('pkid', postpkid);

 
  const requiredPost = posts.find((item) => item.id === parseInt(postpkid));
  console.log("requiredPost", requiredPost);

  const [postTitle, setPostTitle] = useState(requiredPost?.title||"");
  const [postContent, setPostContent] = useState(requiredPost?.content||"");
  const [inputdisabled, setInputdisabled] = useState(true);
 


  if (!requiredPost) { navigate("/posts");}

 

  
  // useEffect(() => {
  //     setPostTitle(post.title);
  //     setPostContent(post.content);
  // }, [post]);
  

  useEffect(() => {
    if (!requiredPost) {
      navigate("/posts");
      return;
    }
  }, []);
  
    console.log(`POST TITLE AND CONTENT:${postTitle}      ${postContent} `);

 
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };




  return (

    <div className="card">
      <Toast ref={toast} />

      <Card title="Post">
        <form action=""
          onSubmit={(e) => {
            editPost(
              e,
              postpkid,
              postTitle,
              postContent,
              setPostTitle,
              setPostContent,
              fetcherror,
              setFetcherror,
              handleAllToasts);
            setTimeout(() => {navigate("/posts") },700);
          }}
        >
        <InputText
            className='w-full mb-4'
            type="text"
            placeholder="Enter Post Title"
            value={postTitle}
            onChange={(e) => setPostTitle(e.target.value)}
            readOnly={inputdisabled}
            disabled={inputdisabled}

          />
          
        <InputTextarea
          className='w-full h-20rem mb-4 '
          autoResize
          placeholder='Describe your Post'
          value={postContent}
          onChange={(e) => setPostContent(e.target.value)}
          readOnly={inputdisabled}
          disabled={inputdisabled}
          />
          
          <div className='flex flex-row justify-content-end'>
            
                <Button
                className='mr-2'
                label="Edit"
                icon="pi pi-pencil"
              onClick={(e) => {
                e.preventDefault();
                setInputdisabled(false);
              }}
            
            />
                
                
              <Button
                label="Save"
                role='submit'
                icon="pi pi-check"
              
                />
          </div>

        </form>

                
      </Card>
    </div>
  )
}

export default Post